import { gql } from '@apollo/client';

export const AccountingExpenseFragment = gql`
  fragment AccountingExpense on AccountingExpense {
    id
    displayName
    amountCents
    createdAt
  }
`;
